import React, { Component } from 'react';
import { objectSelector } from 'theme/utils';

import './index.less'

class DefaultVariant extends Component {
  render() {
    const { data, variantSelection, variantConfig } = this.props;

    return (
      <div className='variants variants--anonymous'>
        <div className='variants--anonymous__title'>{data.attribute_name}</div>
        {data.options.map((item, i) => {
          const disable = !item['in_stock'];
          const selected = item['is_selected'];
          return (
            <div
              className={`variant ${disable ? 'disable no-stock' : ''} ${
                selected ? 'selected' : ''
              }`}
              key={i}
              onClick={() =>
                variantSelection(
                  variantConfig.key,
                  objectSelector(item, variantConfig.value)
                )
              }
            >
              {objectSelector(item, variantConfig.label)}
            </div>
          );
        })}
      </div>
    );
  }
}

export default DefaultVariant;



// WEBPACK FOOTER //
// ./src/plugins/tfs/pages/product/detail/DefaultVariant.js